/**
 * Money formatting.
 *
 * Prices cross the API as integer cents, never floats, so that rounding is
 * decided once at render time instead of drifting through arithmetic.
 */

/** Whole dollars when the amount is round, cents otherwise ($425, $425.50). */
export function formatPriceCents(cents: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
    }).format(cents / 100);
}
